<div *ngIf="autoevaluacion && autoevaluacion.id > 0" class="student-date-chip">
    <div class="student-date-chip-info">
    <div class="student-date-chip__date"><mat-icon class="md-14">calendar_today</mat-icon><span>{{fechaAplicar | date: 'dd LLL yyyy'}}</span>
    <!-- <mat-icon class="md-14 gray" role="button" matTooltip="Datos de config.">info</mat-icon></div> -->
    <mat-icon *ngIf="(autoevaluacion.requiereAutoevaluacion || autoevaluacion.requiereAutoevaluacionComentario) && !autoevaluacion.completoAutoevaluacion" class="md-14 gray" role="button">info</mat-icon></div>
    <div *ngIf="(autoevaluacion.requiereAutoevaluacion || autoevaluacion.requiereAutoevaluacionComentario)" [ngClass]="{'chip-status__alert': !autoevaluacion.completoAutoevaluacion}">
      {{autoevaluacion.completoAutoevaluacion ? 'Autoevaluado': 'Autoevaluacion requerida'}}
    </div>
  </div>
  <div class="student-date-chip__actions">
    <button [routerLink]="['/estudio', 'autoevaluacion', 'eventoMateria', unidadEventoMateriaId, 'alumno', alumnoId]" mat-button color="primary"
    >
    <!-- [matBadge]="'C'" -->
      {{autoevaluacion.completoAutoevaluacion || (!autoevaluacion.requiereAutoevaluacion || !autoevaluacion.requiereAutoevaluacionComentario) ? 'Ver retroalimentación' : 'Autoevaluar'}}</button>
  </div>
</div>
